// @flow
import React, {cloneElement, PureComponent} from 'react';
import {findDOMNode} from 'react-dom';
import load from 'load-script';

export const GDPR_BANNER_ID = 'gdpr-banner';

type State = {
    bannerLoaded: boolean
};

export type Props = {
    bannerVersion: string,
    fullLocale: string
};

export default class GDPRBanner extends PureComponent<Props, State> {
    bannerRef: any;

    constructor() {
        super();

        this.state = {
            bannerLoaded:
                typeof window !== 'undefined'
                    ? !!(window.cookieconsent && window.cookieconsent.gdpr)
                    : false
        };
    }

    setBannerRef = (ref: ?Object) => {
        this.bannerRef = ref;

        if (ref) {
            this.initBanner();
        }
    };

    initBanner = () => {
        const {bannerLoaded} = this.state;

        if (!bannerLoaded) {
            load(
                this.getGdprBannerURL(),
                {attrs: {crossorigin: 'anonymous'}},
                this.onGdprLoaded
            );
            return;
        }

        this.onGdprLoaded();
    };

    getGdprBannerURL = () => {
        const {bannerVersion, fullLocale} = this.props;

        return `//csvcus.homeaway.com/rsrcs-crs/gdpr-banner/${bannerVersion}/gdpr.${
            fullLocale.split(/_|-/)[0]
        }.min.js?cors=true`; // include cache-bust param signifying we've intentionally opted in to CORS routes
    };

    onGdprLoaded = () => {
        this.setState({bannerLoaded: true});
        const node: any = findDOMNode(this.bannerRef);
        const gdprBannerRef = document.getElementById(GDPR_BANNER_ID);

        if (gdprBannerRef) {
            node.appendChild(gdprBannerRef);
        }
    };

    render() {
        return cloneElement(<div className="GDPRBannerContainer" />, {
            ref: this.setBannerRef
        });
    }
}
